export default __webpack_public_path__ + "static/media/animation-arrow9.c3ced06c.gif";